/** Matches `var(--cads-color-…)`; returns the palette family stem (e.g. `green` from `green-deep`). */
export function cadsSemanticFamilyStem(color: string | undefined): string | null {
  const m = color?.trim().match(/^var\(\s*--cads-color-([a-z0-9-]+)\s*\)$/i);
  if (!m) {
    return null;
  }
  let name = m[1];
  if (name.endsWith('-deep')) {
    name = name.slice(0, -'-deep'.length);
  } else if (name.endsWith('-pastel')) {
    name = name.slice(0, -'-pastel'.length);
  }
  return name || null;
}

/** CSS variables for color-aware hover/active chrome on `cads-icon-tile-button` (from `config.icon.color`). */
export function cadsIconTileButtonInteractionVars(color: string | undefined): Record<string, string> {
  const displayColor = color?.trim() || 'var(--cads-color-mid-gray)';
  const stem = cadsSemanticFamilyStem(displayColor);
  if (stem) {
    return {
      '--cads-icon-tile-button-base': `var(--cads-color-${stem})`,
      '--cads-icon-tile-button-pastel': `var(--cads-color-${stem}-pastel)`,
      '--cads-icon-tile-button-deep': `var(--cads-color-${stem}-deep)`,
    };
  }
  return {
    '--cads-icon-tile-button-base': displayColor,
    '--cads-icon-tile-button-pastel': `color-mix(in srgb, ${displayColor} 15%, var(--cads-color-surface))`,
    '--cads-icon-tile-button-deep': displayColor,
  };
}
